import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Request from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {BulletLine} from '../Components/BulletLine';
import {CampusDashboardCard} from './CampusDashboardCard';


const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '15px 15px 5px 15px',
    overflow: 'hidden',
    height: '100%'
}

const inputStyle: CSSProperties = {
    width: '225px',
    height:'40px',
    textAlign: 'center',
    margin: '5px',
    fontSize: '14px',
    lineHeight: '3.0em',
    border:'1px solid black',
    fontFamily:'BarlowLight'
}

const changeStyle: CSSProperties = {
    width: '225px',
    height:'40px',
    textAlign: 'center',
    margin: '35px auto',
    fontSize: '14px',
    lineHeight: '3.0em',
    fontFamily:'Lulo',
    color:'white',
    cursor:'pointer',
    backgroundColor:'rgb(226, 117, 88)',
}

let btnStyle = Object.assign({}, Tgcc.Styles.grayButton, {margin: 'auto 0px',fontFamily:'Lulo', height: '16px', fontSize: '12px', lineHeight: '16px', width:'100px', alignSelf:'center'});
let btnDisabledStyle = Object.assign({}, btnStyle, {color: 'rgba(99,99,99,0.3)'});
let newPassword= Object.assign({},inputStyle,{margin:'43px 5px 5px 5px'})

export class _MajorAccountsPasswordCard extends React.Component<Tgcc.BaseProps, any>{
    
    state = { 
        error: null, 
        isWaiting: false,
        currentPassword: null,
        newPassword: null,
        confirmPassword: null
    };

    okToUpdate = () => {
        if(!this.state.currentPassword || this.state.currentPassword.length < 6){
            return false;
        }
        if(!this.state.newPassword || this.state.newPassword.length < 6){
            return false;
        }
        if(!this.state.confirmPassword || this.state.confirmPassword.length < 6){
            return false;
        }
        if(this.state.newPassword != this.state.confirmPassword){
            return false;
        }
        return true;
    }

    doUpdate = () => {
        if(this.props.state.LoginData){
            this.setState({isWaiting: true});
            Request.changeUserPassword(this.props.state.LoginData, this.state.currentPassword, this.state.newPassword, this.changed, this.error);
        }
    }
    
    changed = () => {
        this.setState({error: "Password changed", isWaiting: false, currentPassword: "", newPassword: "", confirmPassword: ""})
    }

    error = (err: string) => {
        if(err.toString().toUpperCase() == "INCORRECT PASSWORD.")
            this.setState({error: "Old password is incorrect", isWaiting: false});
        else 
            this.setState({error: err, isWaiting: false});
    } 

    currentPasswordChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var val = evt.currentTarget.value;
        var msg = !val || val.trim().length < 6 ? "old password too short" 
            : this.checkNewPassword(this.state.newPassword, this.state.confirmPassword);
        this.setState({ currentPassword: evt.currentTarget.value, error: msg});
    }

    checkNewPassword = (pw: string, pw2: string) => {
        if(!pw || pw.trim().length < 6)
            return "new password too short";
        if(pw != pw2)
            return "new passwords don't match";
        return null;
    }

    
    newPasswordChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var pw = evt.currentTarget.value;
        var msg = this.checkNewPassword(pw, this.state.confirmPassword);
        this.setState({ newPassword: evt.currentTarget.value, error: msg});
    }

    confirmPasswordChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        var cpw = evt.currentTarget.value;
        var msg = this.checkNewPassword(cpw, this.state.newPassword);
        this.setState({ confirmPassword: evt.currentTarget.value, error: msg});
    }

    render(){
        var updateBtn = this.okToUpdate() ?
            <div style={changeStyle} key={1} onClick={this.doUpdate}>Change</div>
            : <div key={2} style={changeStyle}>Change</div>
        if(this.state.isWaiting)
            updateBtn = Tgcc.workingGif;

        var err = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : null;
        
        return (
            <CampusDashboardCard title="Change Password">
                <div style={containerStyle}>
                    <input value={this.state.currentPassword||''} style={inputStyle} type='password' name='currentPassword' placeholder="old password" onChange={this.currentPasswordChanged} />
                    <input value={this.state.newPassword||''} style={newPassword} type='password' name='newPassword' placeholder="new password" onChange={this.newPasswordChanged} />
                    <input value={this.state.confirmPassword||''} style={inputStyle} type='password' name='confirmPassword' placeholder="confirm new password" onChange={this.confirmPasswordChanged} />
                    {err}
                    {updateBtn}
                </div>
            </CampusDashboardCard>
        )
    }
}


const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state };
};
export var MajorAccountsPasswordCard = connect(mapStateToProps)(Radium(_MajorAccountsPasswordCard));